import WeatherIcon from "./WeatherIcon";

export default function WeatherForecastDay(props) {
  function time() {
    let date = new Date(props.data.time * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return days[day];
  }

  function iconCode() {
    let icon = props.data.condition.icon;
    return icon;
  }

  function convertTemperature(temp) {
    if (props.unit === "imperial") {
      return Math.round((temp * 9) / 5 + 32);
    }
    return Math.round(temp);
  }

  function maxTemp() {
    let max = convertTemperature(Math.round(props.data.temperature.maximum));
    return max;
  }

  function minTemp() {
    let min = convertTemperature(Math.round(props.data.temperature.minimum));
    return min;
  }

  return (
    <div className="WeatherForecastDay">
      <div className="text-center">
        <div className="forecast-day">{time()}</div>
        <WeatherIcon code={iconCode()} size={42} />
        <div className="forecast-temperatures">
          <span className="forecast-max">{maxTemp()}°</span>{" "}
          <span className="forecast-min"> {minTemp()}°</span>
        </div>
      </div>
    </div>
  );
}
